module.exports = __webpack_public_path__ + "static/media/Pampalche_2_t.84e7c015.jpg";